import { createSelector } from '@reduxjs/toolkit'
import { Slice } from './types'
import { COMMA, MAX_PAGE_SIZE, CATALOG_SORT } from 'lib/core/resources/constants'
import { RootState } from 'lib/core/data/reducer'

export const getSlice = (state: RootState): Slice => {
  return state.common.storeConfig
}

export const getAccountRequiresConfirmation = (state: RootState) => {
  return Boolean(getSlice(state).payload?.create_account_confirmation)
}

export const getStoreTimezone = (state: RootState) => {
  return getSlice(state).payload?.timezone
}

export const getPageSizeDefault = (state: RootState) => {
  return getSlice(state).payload?.grid_per_page ?? MAX_PAGE_SIZE
}

export const getIsError = (state: RootState) => {
  return getSlice(state).isFailure
}

export const getPageSizesAvailable = (state: RootState) => {
  return getSlice(state).payload?.grid_per_page_values?.split(COMMA) ?? [
    (MAX_PAGE_SIZE).toString(),
    (MAX_PAGE_SIZE * 2).toString()
  ]
}

export const getCatalogSortDefault = (state: RootState) => {
  return getSlice(state).payload?.catalog_default_sort_by ?? CATALOG_SORT.DEFAULT_SORT
}

export const isDefined = (state: RootState) => {
  return getSlice(state).payload !== undefined
}

export const getHeaderLogo = (state: any) => {
  const slice = getSlice(state)
  const logo = slice.payload?.header_logo_src
  const baseMediaUrl = slice.payload?.secure_base_media_url
  const fullLogoUrl = logo ? `${baseMediaUrl}logo/${logo}` : ''
  return fullLogoUrl
}

export const getDefaultMetaData = (state: RootState) => {
  const slice = getSlice(state)
  return {
    metaKeywords: slice.payload?.default_keywords,
    metaDescription: slice.payload?.default_description,
    metaTitle: slice.payload?.default_title
  }
}

export const getStoreViewCode = (state: RootState) => {
  const slice = getSlice(state)
  return slice.payload?.code
}

export const getCountryConfig = createSelector(
  getSlice,
  (slice) => {
    const postalCodeOptional = slice.payload?.country_options.optional_zip_countries?.reduce((list: Partial<Record<string, true>>, countryCode) => {
      list[countryCode] = true
      return list
    }, {}) ?? {}

    const regionRequired = slice.payload?.region_options.state_required?.reduce((list: Partial<Record<string, true>>, countryCode) => {
      list[countryCode] = true
      return list
    }, {}) ?? {}

    return {
      postalCodeOptional,
      regionRequired
    }
  }
)
